<template>
  <div class="shootingScore-list">
    <el-card class="parent-info-card" shadow="hover">
      <div class="shootingScore-type-info">
        <div class="info-row">
          <el-button icon="el-icon-back" @click="$router.back()" >返回</el-button>
          <el-button v-if="isShowButton" type="primary" @click="handleActivityQuery">查询成绩</el-button>
          <div class="title-container">
            <span class="info-label">射击场次：</span>
            <span class="info-value">{{ activityName || '练习场'}}</span>
          </div>
          <div class="pk-btn-container">
            <span v-if="pkSelectMode" class="selected-tip">已选 {{ selectedTargets.length }}/2</span>
            <el-button 
              :type="pkSelectMode ? 'danger' : 'primary'" 
              @click="togglePkMode"
            >
              {{ pkSelectMode ? '取消' : '双人PK' }}
            </el-button>
          </div>
        </div>
      </div>
    </el-card>

    <!-- 设备缩略卡片网格 -->
    <div class="target-grid">
      <!-- 设备卡片：循环当前页的设备列表 -->
      <div class="target-card" v-for="target in currentPageTargets" :key="target.imei" @click="handleCardClick(target)"
        :class="{ 'card-selected': selectedTargets.includes(target.imei) }"
      >
        <div v-if="pkSelectMode" class="select-checkbox">
          <i :class="selectedTargets.includes(target.imei) ? 'el-icon-check' : 'el-icon-circle-plus-outline'"></i>
        </div>
        <!-- 左侧区域 -->
        <div class="left-container">
          <!-- 靶纸区域 -->
          <div class="target-paper">
            <div class="target-container">
              <!-- 靶纸背景 -->
              <div class="target-bg" :style="{ backgroundImage: 'url(' + require('@/assets/target-background.jpg') + ')'}"></div>
              <!-- 战区+靶编号 -->
              <div class="war-target">
                {{ target.warZone }}-{{ target.targetNo }}
              </div>
              <!-- 在线状态 -->
              <el-button class="target-status-btn" circle size="small"
                :type="target.onlineStatus === 1 ? 'success' : 'danger'" 
              ></el-button>
              <!-- 当前环数（0.0环） -->
              <div class="ring-score">
                {{ target.ringScore || '0.0' }}
              </div>
              <!-- 当前弹着点 -->
              <div 
                v-if="target.hitX && target.hitY && target.ringScore > 0"
                class="hit-point"
                :style="{
                  left: `${target.hitX / 50 * 100}%`,
                  top: `${target.hitY / 50 * 100}%`,
                  width: pointSize,
                  height: pointSize
                }"
              >
                <span class="shot-seq">{{ target.shotSeq }}</span>
              </div>
            </div>
          </div>
          <div class="status-container" style="background-color: #e9e9eb;">
            <span class="label">射手编号：</span>
            <span class="value">No. {{ String(target.shooterNo || '').padStart(6, '0') }}</span>
          </div>
          <div class="status-container" style="background-color: #fff;">
            <span class="label">射手姓名：</span>
            <span class="value">{{ target.shooterName ? target.shooterName : '--' }}</span>
          </div>
          <div class="status-container" style="background-color: #e9e9eb;">
            <span class="label">射击状态：</span>
            <el-tag :type="target.onlineStatus !== 1 ? 'danger' : (target.roundStatus === '0' ? 'success' : 'danger')">
              {{ target.onlineStatus !== 1 ? '射击结束' : (target.roundStatus === '0' ? '开始射击' : '射击结束') }}
            </el-tag>
          </div>
        </div>
        <!-- 右侧文字区域 -->
        <div class="target-info">
          <div class="target-info-row">
            <span class="label">发序</span>
            <span class="value">{{ target.shotSeq ? target.shotSeq : '0' }}</span>
          </div>
          <div class="target-info-row">
            <span class="label">当前成绩</span>
            <span class="value">{{ target.ringScore ? target.ringScore : '0.0' }}</span>
          </div>
          <div class="target-info-row">
            <span class="label">总成绩</span>
            <span class="value">{{ target.totalScore ? target.totalScore : '0.0' }}</span>
          </div>
          <div class="target-info-row">
            <span class="label">当前用时</span>
            <span class="value">{{ target.shotDuration ? target.shotDuration : '00:00.00' }}</span>
          </div>
          <div class="target-info-row">
            <span class="label">总用时</span>
            <span class="value">{{ target.shotTotalDuration ? target.shotTotalDuration : '00:00.00' }}</span>
          </div>
        </div>
      </div>

      <!-- 空数据占位：当前页无设备时显示 -->
      <div class="empty-card" v-if="currentPageTargets.length === 0">
        暂无精度靶数据
      </div>
    </div>

    <!-- 分页 -->
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
      :page-sizes="[10]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
      :total="total"></el-pagination>
  </div>
</template>
<script>
import activityApi from '../../api/activity'
import targetApi from '../../api/target';
import recordApi from '../../api/record';
import store from '../../store';
import SockJS from 'sockjs-client';
import { Stomp } from '@stomp/stompjs';
import config from '../../config/config';

export default {
  name: 'ShootingScoreList',
  data() {
    return {
      // WebSocket通信配置
      subscriptions: [], // 订阅的设备IMEI
      stompClient: null,
      isConnected: false,
      subInstanceMap: {},
      wsEndpoint: config.WebSocketURL + '/ws',
      deviceTopicPrefix: '/topic/shooting-data/',
      hasLoadedData: false,        // 标记是否已加载历史数据
      isFirstWsConnect: true,      // 标记是否是WebSocket首次连接
      // 页面业务数据
      targets: [], // 靶数据列表
      targetMap: {}, // 靶数据映射表：key=imei，value=靶数据对象（快速查找）
      total: 0,
      pageSize: 10,
      currentPage: 1,
      activityId: null, // 场次ID
      activityName: '', // 场次名称
      listRefreshTimer: null, // 列表刷新定时器
      hitPointLastImg: require('@/assets/hit-point-last.png'), // 弹着点图片
      pkSelectMode: false, // 是否进入PK选择模式
      selectedTargets: [], // 选中的靶位IMEI列表（最多2个）
      isShowButton: false, // 是否显示成绩按钮

      userOrgs: store.state.user.userInfo.orgs,
    };
  },
  computed: {
    // 计算当前页要显示的靶数据列表
    currentPageTargets() {
      return this.targets;
    },
    // 弹着点尺寸
    pointSize() {
      return `${(100 / 50) * 7}%`; 
    },
  },
  mounted() {
    this.activityId = this.$route.query.activityId;
    if (this.activityId) {
      this.loadActivityInfo(this.activityId);
      this.isShowButton = true;
    }
    this.loadTargets();
    this.listRefreshTimer = setInterval(() => {
      this.loadTargets();
    }, 5 * 1000); // 5000毫秒=5秒
  },
  // 监听选中数量，选够2个自动跳转
  watch: {
    selectedTargets: {
      handler(newVal) {
        if (newVal.length === 2) {
          // 选够2个，跳转PK页面，把选中的2个IMEI及是否射击结束传过去
          // 1. 根据选中的IMEI，从已有的targetMap中获取完整靶位数据
          const Target1 = this.targetMap[newVal[0]];
          const Target2 = this.targetMap[newVal[1]];
          // 2. 分别计算两个靶位的roundStatus
          // 第一个靶位的roundStatus计算
          const Target1HasBusinessData = Target1?.shotSeq > 0;
          const Target1IsRoundCompleted = Target1?.roundStatus === '1';
          const Target1RoundStatus = (Target1HasBusinessData && Target1IsRoundCompleted) ? '1' : '0';
          // 第二个靶位的roundStatus计算
          const Target2HasBusinessData = Target2?.shotSeq > 0;
          const Target2IsRoundCompleted = Target2?.roundStatus === '1';
          const Target2RoundStatus = (Target2HasBusinessData && Target2IsRoundCompleted) ? '1' : '0';
          this.$router.push({
            name: 'ShootingScorePK',
            query: {
              imei1: newVal[0],
              roundStatus1: Target1RoundStatus,
              imei2: newVal[1],
              roundStatus2: Target2RoundStatus,
              target1: Target1,
              target2: Target2,
            }
          });
          // 跳转后自动退出PK模式，清空选中
          this.togglePkMode();
        }
      },
    }
  },
  beforeDestroy() {
    // 先取消所有订阅，再断开连接
    this.unsubscribeAllDevices()
    this.disconnectWebSocket()
    if (this.listRefreshTimer) {
      clearInterval(this.listRefreshTimer);
      this.listRefreshTimer = null; // 清空变量，优化内存
    }
    this.pkSelectMode = false;
    this.selectedTargets = [];
  },
  methods: {
    // 加载场次信息
    loadActivityInfo(activityId) {
      activityApi.findById(activityId).then(res => {
        if (res.success) {
          this.activityName = res.data.activityName;
        }
      });
    },
    // 加载靶数据
    loadTargets() {
      // 根据是否有场次ID来加载靶数据
      // 如果有场次ID，加载该场次的靶数据，否则加载所有靶数据
      // 1. 组装公共请求参数
      const params = this.activityId 
        ? { activityId: this.activityId, page: this.currentPage, size: this.pageSize }
        : { userOrgIds: this.userOrgs.map(org => org.id), page: this.currentPage, size: this.pageSize };
      // 2. 调用对应的API（提取为公共请求逻辑）
      const apiCall = this.activityId 
        ? targetApi.findByActivityId(params)
        : targetApi.findAll(params);
      apiCall.then(response => {
        if (response.success) {
          const newTargets = response.data.data;
          this.total = response.data.total;
          // 核心：增量合并新旧数据（保留WebSocket实时数据，仅同步数据库字段）
          this.mergeTargets(newTargets);
          // 3. 仅在首次加载或设备列表变化时初始化WebSocket
          if (!this.ws) {
            this.initWebSocket();
          }
        } else {
          this.$message.error(response.message);
        }
      }).catch(error => {
        this.$message.error('加载靶数据失败：' + error.message);
      });
    },
    mergeTargets(newTargets) {
      const newTargetMap = {};
      const updatedTargets = [...this.targets]; // 浅拷贝旧列表，避免直接修改原数组
      // 1. 合并已有设备（保留实时数据，仅更新数据库字段）
      updatedTargets.forEach(oldTarget => {
        const newTarget = newTargets.find(t => t.imei === oldTarget.imei);
        if (newTarget) {
          // 仅同步数据库需要更新的字段（根据你的业务调整）
          oldTarget.warZone = newTarget.warZone;
          oldTarget.targetNo = newTarget.targetNo;
          oldTarget.onlineStatus = newTarget.onlineStatus;
          // 其他需要从数据库同步的字段...
          newTargetMap[oldTarget.imei] = oldTarget;
        }
      });
      // 2. 新增数据库中存在但旧列表没有的设备
      newTargets.forEach(newTarget => {
        if (!this.targetMap[newTarget.imei]) {
          // 初始化新增设备的报文字段（确保响应式）
          const initTarget = {
            ...newTarget,
            ringScore: '0.0',
            shotSeq: '0',
            roundStatus: '1',
            shooterNo: '000000',
            shooterName: '--',
            shotDuration: '00:00:00',
            shotTotalDuration: '00:00:00',
            hitX: 0,
            hitY: 0,
          };
          updatedTargets.push(initTarget);
          newTargetMap[newTarget.imei] = initTarget;
        }
      });
      // 3. 移除数据库中不存在的设备
      this.targets = updatedTargets.filter(oldTarget => newTargetMap[oldTarget.imei]);
      // 4. 更新映射对象和订阅列表
      this.targetMap = newTargetMap;
      this.subscriptions = Object.keys(newTargetMap);
    },
    // 每页条数变化时
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.targets = [];
      this.targetMap = {};
      this.loadTargets(); // 重新加载
    },
    // 当前页变化时
    handleCurrentChange(val) {
      this.currentPage = val;
      this.targets = [];
      this.targetMap = {};
      this.loadTargets(); // 重新加载
    },
    // 切换PK选择模式
    togglePkMode() {
      this.pkSelectMode = !this.pkSelectMode;
      // 切换模式时清空选中状态
      this.selectedTargets = [];
    },
    // 卡片点击事件（兼容跳转+PK选中）
    handleCardClick(target) {
      // PK模式下：切换选中状态
      if (this.pkSelectMode) {
        this.toggleTargetSelect(target.imei);
        return;
      }
      // 非PK模式下：执行跳转详情页逻辑
      this.goToShootingScore(target);
    },
    // 切换靶位选中状态
    toggleTargetSelect(imei) {
      const index = this.selectedTargets.indexOf(imei);
      // 已选中：取消选中
      if (index > -1) {
        this.selectedTargets.splice(index, 1);
        return;
      }
      // 未选中：判断是否超过2个
      if (this.selectedTargets.length >= 2) {
        this.$message.warning('最多只能选择2个靶位进行PK');
        return;
      }
      // 加入选中列表
      this.selectedTargets.push(imei);
    },
    // 初始化WebSocket（STOMP协议）
    initWebSocket() {
      // 1. 把SockJS包装成工厂函数传入Stomp.over
      this.stompClient = Stomp.over(() => new SockJS(this.wsEndpoint));
      // 2. 配置自动重连（可选，解决警告同时开启重连）
      this.stompClient.configure({
        autoReconnect: true, // 开启自动重连
        reconnectDelay: 5000, // 重连间隔5秒
        debug: () => {} // 关闭调试日志
      });
      this.stompClient.connect({}, 
        () => {
          this.isConnected = true;
          this.subscribeAllDevices();
        },
        (err) => {
          this.isConnected = false;
          console.error('WebSocket连接失败：', err);
        }
      );
    },
    // 订阅所有配置的设备主题
    subscribeAllDevices() {
      if (!this.stompClient || !this.isConnected) return
      this.subscriptions.forEach(imei => {
        // 避免重复订阅
        if (this.subInstanceMap[imei]) return

        // 拼接设备专属主题
        const topic = `${this.deviceTopicPrefix}${imei}`;
        // 订阅主题（@stomp/stompjs 的 subscribe 方法）
        const subscription = this.stompClient.subscribe(topic, msg => {
          // 接收消息并处理
          this.handleDeviceMessage(imei, msg.body);
        })
        // 存储订阅实例（用于后续取消订阅）
        this.subInstanceMap[imei] = subscription
      })
      if (this.isFirstWsConnect && !this.hasLoadedData) {
        // 根据订阅的imei重新发送进行中的最新报文
        recordApi.pushLatestShootData(this.subscriptions).then(res => {
          if (!res.success) {
            this.$message.error(res.message);
          }
        });
        this.hasLoadedData = true; // 标记为已加载
        this.isFirstWsConnect = false; // 首次连接后，永久置为false
      }
    },
    // 处理设备推送的报文
    handleDeviceMessage(imei, content) {
      const msgObj = JSON.parse(content);
      const { pkgType } = msgObj;
      const target = this.targetMap[imei];
      if (target) {
        // 根据pkgType执行不同逻辑
        switch (pkgType) {
          case '1':// 开始射击
            // 清空所有数据，重新写入射手编号、战区、靶号等
            this.$set(target, 'warZone', msgObj.warZone || '0');
            this.$set(target, 'targetNo', msgObj.targetNo || '0');
            this.$set(target, 'shooterNo', String(msgObj.shooterNo || '').padStart(6, '0'));
            this.$set(target, 'shooterName', msgObj.shooterName || '--');
            this.$set(target, 'roundStatus', msgObj.roundStatus || '0');
            this.$set(target, 'shotSeq', '0');
            this.$set(target, 'ringScore', '0.0');
            this.$set(target, 'totalScore', '0.0');
            this.$set(target, 'shotDuration', '00:00.00');
            this.$set(target, 'shotTotalDuration', '00:00.00');
            this.$set(target, 'hitX', 0);
            this.$set(target, 'hitY', 0);
            break;
          case '2':// 停止射击
            this.$set(target, 'roundStatus', msgObj.roundStatus || '1');
            break;
          case '3':// 射击数据
            // 处理弹着点+成绩展示
            if (typeof msgObj.warZone !== 'undefined' && msgObj.warZone !== null && msgObj.warZone !== '') {
              this.$set(target, 'warZone', msgObj.warZone);
            }
            if (typeof msgObj.targetNo !== 'undefined' && msgObj.targetNo !== null && msgObj.targetNo !== '') {
              this.$set(target, 'targetNo', msgObj.targetNo);
            }
            if (typeof msgObj.shooterNo !== 'undefined' && msgObj.shooterNo !== null && msgObj.shooterNo !== '') {
              this.$set(target, 'shooterNo', String(msgObj.shooterNo).padStart(6, '0'));
            }
            if (typeof msgObj.shooterName !== 'undefined' && msgObj.shooterName !== null && msgObj.shooterName !== '') {
              this.$set(target, 'shooterName', msgObj.shooterName);
            }
            if (msgObj.roundStatus === '0') {
              this.$set(target, 'roundStatus', msgObj.roundStatus);
            }
            this.$set(target, 'shotSeq', msgObj.shotSeq || '0');
            this.$set(target, 'ringScore', msgObj.ringScore || '0.0');
            this.$set(target, 'totalScore', msgObj.totalScore || '0.0');
            this.$set(target, 'shotDuration', this.formatTimeToMMSSMS(msgObj.shotDuration) || '00:00.00');
            this.$set(target, 'shotTotalDuration', this.formatTimeToMMSSMS(msgObj.shotTotalDuration) || '00:00.00');
            const originHitX = Number(msgObj.hitX) || 0;
            const originHitY = Number(msgObj.hitY) || 0;
            const ringScore = Number(msgObj.ringScore) || 0;
            // 非XY都为0且原始XY都<50 且 环数>0 时才更新弹着点
            if (!((originHitX === 0 && originHitY === 0) || originHitX > 50 || originHitY > 50) && ringScore > 0) {
              this.$set(target, 'hitX', originHitX + 1);
              this.$set(target, 'hitY', originHitY + 1);
            }
            break;
          default:
            console.warn('未知pkgType：', pkgType);
        }
      } else {
        console.warn(`未找到 IMEI 为 ${imei} 的设备数据`);
      }
    },
    // 取消所有设备的订阅
    unsubscribeAllDevices() {
      // 循环 subInstanceMap，取消每个订阅
      Object.keys(this.subInstanceMap).forEach(imei => {
        const subscription = this.subInstanceMap[imei] // 修正：定义变量 subscription
        this.subInstanceMap[imei]?.unsubscribe();
      })
      // 清空订阅实例映射
      this.subInstanceMap = {}
    },
    // 断开WebSocket连接
    disconnectWebSocket() {
      if (this.stompClient?.connected) {
        this.stompClient.disconnect();
      }
      this.isConnected = false;
      this.isFirstWsConnect = true; // 重连时重置，可重新加载历史数据
      this.hasLoadedData = false;
    },
    goToShootingScore(target) {
      // 1. 条件判断：有业务数据 + roundStatus为'1'（射击结束）
      const hasBusinessData = target.shotSeq > 0;
      const isRoundCompleted = target.roundStatus === '1';
      // 2. 动态生成路由参数
      const routeParams = {
        imei: target.imei,
        // 满足条件时传标识，否则设为'0'
        ...(hasBusinessData && isRoundCompleted ? { roundStatus: '1' } : { roundStatus: '0' }),
        target: target,
      };
      // 3. 跳转详情页
      this.$router.push({
        name: 'ShootingScore',
        query: routeParams
      });
    },
    // 按场次名称查询
    handleActivityQuery() {
      if (!this.activityId) {
        this.$message.warning('当前无进行中场次');
        return;
      }
      // 跳转页面
      this.$router.push({
        name: 'RecordList',
        query: { activityId: this.activityId }
      });
    },
    // 格式化函数 - 不足四位前面补零，固定四位
    formatFourDigits(value) {
      // 先转成字符串，去除空值/非数字情况，默认值为'0'
      const str = (value || '0').toString();
      // padStart(4, '0')：不足4位时，在开头补0，直到长度为4
      return str.padStart(4, '0');
    },
    // 数字时间格式化为00:00.00
    formatTimeToMMSSMS(timeValue) {
      // 处理空值/非数字，默认0
      const timeNum = Number(timeValue) || 0;
      // 拆分：分钟 = 总秒数÷60；秒 = 总秒数%60；毫秒 = 小数部分×100（保留两位）
      const minutes = Math.floor(timeNum / 60);
      const seconds = Math.floor(timeNum % 60);
      const milliseconds = Math.round((timeNum - Math.floor(timeNum)) * 100);
      // 补零为两位字符串
      const fmtMin = String(minutes).padStart(2, '0');
      const fmtSec = String(seconds).padStart(2, '0');
      const fmtMs = String(milliseconds).padStart(2, '0');
      // 拼接成00:00.00格式
      return `${fmtMin}:${fmtSec}.${fmtMs}`;
    }
  }
}
</script>
<style scoped>
.parent-info-card {
  width: 100%;
  margin-bottom: 40px;
  border-left: 3px solid #409EFF;
  /* 保持标识性边框 */
  box-sizing: border-box;
  padding: 0 10px;
}
.shootingScore-type-info {
  font-size: 4vh;
  font-weight: bold;
}
.info-row {
  display: flex;
  align-items: center; /* 上下居中 */
  justify-content: space-between; /* 左中右三等分布局 */
  width: 100%;
}
.title-container {
  flex: 1;
  text-align: center;
}
.pk-btn-container {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 180px;
  justify-content: flex-end;
}
.selected-tip {
  font-size: 14px;
  color: #409EFF;
  font-weight: bold;
}
/* 网格布局：一行5列，自动换行，最多两行（分页控制） */
.target-grid {
  display: grid;
  /* 核心：一行5列，列宽等分，间距10px */
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 10px;
  overflow: hidden;
  width: 100%; /* 确保不超出父容器 */
  box-sizing: border-box; /* 确保 padding/border 不增加宽度 */
  padding: 0 10px; /* 可选：添加左右内边距，避免卡片贴边 */
  margin-bottom: 40px;
}
/* 单个卡片容器：左右布局（靶纸+文字） */
.target-card {
  display: flex;
  width: 100%;
  flex: 1;
  box-sizing: border-box;
  overflow: hidden;
  align-items: stretch;
  border: 1px solid #000;
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease;
}
/* 左侧整体容器：纵向排列（靶纸 + 下方文字） */
.left-container {
  display: flex;
  flex-direction: column;
  flex-shrink: 0; /* 防止被压缩 */
}
/* 靶纸区域：相对定位，背景图+绝对定位元素 */
.target-paper {
  display: flex;
  flex-shrink: 0;
  width: 300px;
  aspect-ratio: 1/1;
  overflow: hidden;
  box-sizing: border-box;
}
.target-container{
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border: 1px solid #000;
  overflow: hidden;
  font-size: 20px;
}
.select-checkbox {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 99; /* 保证在最上层 */
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #fff;
  border: 2px solid #dcdfe6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #409EFF;
}
/* 选中状态的复选框样式 */
.card-selected .select-checkbox {
  background-color: #409EFF;
  border-color: #409EFF;
  color: #fff;
}
/* 选中状态的卡片高亮 */
.card-selected {
  border: 1px solid #409EFF !important;
  box-shadow: 0 0 8px rgba(64, 158, 255, 0.4);
}
.status-container {
  flex-shrink: 0;
  background-color: #fff;
  box-sizing: border-box;
  border: 1px solid #000;
  border-top: none;
}
/* 靶纸背景图 */
.target-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  z-index: 0;
}
/* 战区-靶编号（左上角） */
.war-target {
  position: absolute;
  top: 10%;
  left: 5%;
  color: #000;
  font-size: 30px;
  font-weight: bold;
  z-index: 10;
}
/* 在线状态（右上角） */
.target-status-btn {
  position: absolute;
  top: 5%;    /* 垂直位置：距离顶部5%，和原文字位置一致 */
  right: 5%;  /* 水平位置：距离右侧5%，和原文字位置一致 */
  z-index: 10;/* 确保按钮在最上层 */
  width: 24px;/* 按钮大小，可根据需要调整 */
  height: 24px;
  padding: 0; /* 去掉内边距，确保纯圆形无多余空间 */
  border: none;/* 去掉默认边框，更简洁 */
}
/* 当前环数（在线状态下方） */
.ring-score {
  position: absolute;
  top: 20%;
  right: 5%;
  color: #000;
  font-size: 30px;
  font-weight: bold;
  z-index: 10;
}
/* 弹着点样式（居中对齐坐标） */
.hit-point {
  position: absolute;
  background-image: url('~@/assets/hit-point-last.png');
  background-size: 100% 100%;
  transform: translate(-50%, -50%);
  z-index: 10;
}
.shot-seq {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-weight: 700;
  font-size: 100%;
}
/* 文字信息区域 */
.target-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  border: 1px solid #000;
  border-left: none;
  font-size: 20px;
}
/* 每组属性的行容器 */
.target-info-row {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* 让标签和值左右对齐 */
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 10px 0px;
}
/* 奇偶行交替背景色（柔和区分） */
.target-info-row:nth-child(odd) {
  background-color: #fff; 
}
.target-info-row:nth-child(even) {
  background-color: #e9e9eb; /* 稍深一点的淡灰色 */
}
/* 空数据占位样式 */
.empty-card {
  grid-column: span 8; /* 占满整行 */
  text-align: center;
  padding: 40px;
  font-size: 14px;
}
</style>